"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenderToJSON = exports.GenderFromJSONTyped = exports.GenderFromJSON = exports.Gender = void 0;
/**
 *
 * @export
 */
exports.Gender = {
    Male: 'MALE',
    Female: 'FEMALE',
    NonBinary: 'NON_BINARY'
};
function GenderFromJSON(json) {
    return GenderFromJSONTyped(json, false);
}
exports.GenderFromJSON = GenderFromJSON;
function GenderFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GenderFromJSONTyped = GenderFromJSONTyped;
function GenderToJSON(value) {
    return value;
}
exports.GenderToJSON = GenderToJSON;
